import { render, staticRenderFns } from "./ReviewsShortsPopup.vue?vue&type=template&id=5fbeed25&scoped=true"
import script from "./ReviewsShortsPopup.vue?vue&type=script&lang=js"
export * from "./ReviewsShortsPopup.vue?vue&type=script&lang=js"
import style0 from "./ReviewsShortsPopup.vue?vue&type=style&index=0&id=5fbeed25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbeed25",
  null
  
)

export default component.exports